import React, { useState } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Send as SendIcon, Email as EmailIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import FollowButton from 'components/common/buttons/FollowButton';
import { useUserContext } from 'shared/contexts/UserContext';
import LabSuggestCallDialog from './LabSuggestCallDialog';

/**
 * A lab's actions: follow, suggest a funding call, message. Labs aren't invited to consortia (people
 * are) and don't get meeting requests; suggestions and messages reach the PI.
 */
export default function LabActions({ lab, size = 'small', fontSize = '1.35rem', sx, showFollow = true }) {
  const navigate = useNavigate();
  const { user } = useUserContext() || {};
  const [suggestOpen, setSuggestOpen] = useState(false);
  const isPI = user?.id && String(user.id) === String(lab.pi);
  const iconSx = (color, hover) => ({ p: 0.5, color, '&:hover': { bgcolor: 'action.hover', color: hover } });

  return (
    <Box display="flex" alignItems="center" gap={0.5} sx={sx} onClick={(e) => e.stopPropagation()}>
      {showFollow && <FollowButton contentType="lab" objectId={lab.id} size="small" variant="outlined" />}
      {!isPI && (
        <>
          <Tooltip title="Suggest a funding call">
            <IconButton size={size} aria-label="Suggest a funding call" sx={iconSx('#ad89ad', '#896b89')}
              onClick={() => setSuggestOpen(true)}>
              <SendIcon sx={{ fontSize }} />
            </IconButton>
          </Tooltip>
          <Tooltip title={`Message the lab (received by ${lab.pi_detail?.name || 'the PI'})`}>
            <IconButton size={size} aria-label="Message the lab" sx={iconSx('#9e9e9e', '#757575')}
              onClick={() => navigate(`/messages/new?lab=${lab.id}`)}>
              <EmailIcon sx={{ fontSize }} />
            </IconButton>
          </Tooltip>
        </>
      )}
      <LabSuggestCallDialog open={suggestOpen} onClose={() => setSuggestOpen(false)} lab={lab} />
    </Box>
  );
}
